import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/pics/success.png'


const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50 bg-black/50 backdrop-blur-sm"
}
const _hoisted_2 = { class: "relative max-w-lg w-full mx-4" }

import { ref } from 'vue'
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'SuccessModal',
  props: {
    show: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any) {

  
  
  
  
  const imageLoaded = ref(false)
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                class: "absolute top-4 right-4 text-white/60 hover:text-white"
              }, _cache[2] || (_cache[2] = [
                _createElementVNode("svg", {
                  class: "w-6 h-6",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12"
                  })
                ], -1)
              ])),
              _createElementVNode("img", {
                src: _imports_0,
                alt: "感謝訂閱",
                class: "w-full h-auto shadow-2xl rounded-lg",
                onLoad: _cache[1] || (_cache[1] = ($event: any) => (imageLoaded.value = true))
              }, null, 32)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})